export default __webpack_public_path__ + "static/media/rollbar.12558b5c.svg";